<template>
    <div :class="['field', {readonly, error: isInvalid(error, invalid)}]" ref="field" :title="value">
        <label>{{label}} <span v-show="labelInfo">- {{labelInfo}}</span></label>
        <div :class="['input', context.name]">
            <span class="prepend"><slot name="prepend"></slot></span>
            <input :readonly="readonly"
                   v-model="value"
                   ref="input"
                   :type="type"
                   :placeholder="placeholder"
                   :name="name"
                   :autocomplete="autocomplete"
                   :value="value"
                   :tabindex="tab_index"
                   :pattern="pattern"
                   :maxlength="maxlength"
                   :class="!value || value.length === 0 ? 'is-empty' : ''"
                   @animationstart="onAnimationStart"
                   @input="handleInput"
                   @change="onChange"
                   @keydown.right="onArrowRight"
                   @keydown.down="onArrowDown"
                   @keydown.left="onArrowLeft"
                   @keydown.up="onArrowUp"
                   @keydown="onKeyDown"
                   @keypress="onKeyPress"
                   @focus="onFocus"
                   @blur="onBlur" />
            <span class="append"><slot name="append"></slot></span>
        </div>
        <div class="error message">{{error}}</div>
    </div>

</template>

<script>
    import Vue from 'vue'
    // import InputMask from 'inputmask' // This lib is bugged as hell can't type anything with the date extensions

    import Constants from '@/store/constants'
    /*
        For security reasons, chrome hides the value of autofilled inputs
        see https://medium.com/@brunn/detecting-autofilled-fields-in-javascript-aed598d25da7 for a full explanation
    */


    export default {
        name: 'TextInput',
        props: {
            originalValue: { type: [String, Number], default: "" },
            placeholder: { type: String, default: "" },
            maxlength: { type: Number, default: 100 },
            pattern: { type: String },
            mask: { type: [String, Object] },
            readonly: { type: Boolean, default: false },
            size: String,
            label: String,
            labelInfo: String,
            type: { type: String, default: "text" },
            name: String,
            autocomplete: { type: String, default: 'on' },
            error: String,
            invalid: Boolean,
            tab_index: { type: Number, default: null }
        },
        watch: {
            originalValue(val, prevVal) {
                this.value = val;
            }
        },
        data() {
            return {
                context: Constants.context,
                value: this.originalValue,
                content: this.value || ''
            }
        },
        methods: {
            isInvalid(err, invalid) {
                return (err || invalid)
            },
            focus() {
                this.$refs.input.focus()
            },
            checkEmpty() {
                if (!this.$refs.input) return
                const isAutofilled = this.$refs.input.classList.contains('autofilled')
                const input = this.$refs.input
                const hasValue = (input.value && input.value.length) || (input.value && input.value.toString().length) || this.placeholder.length// value can be string or number

                if (isAutofilled || hasValue) {
                    this.$refs.field.classList.remove('empty')
                }
                else {
                    this.$refs.field.classList.add('empty')
                }
                return true
            },
            onAutoFillCancel(el) {
                el.classList.remove('autofilled')
            },
            onAutoFillStart(el) {
                el.classList.add('autofilled')
                // this.checkEmpty()
            },
            onAnimationStart({ target, animationName }) { // trick to detect autofill values in chrome
                if (animationName.startsWith('onAutoFillStart')) {
                    return this.onAutoFillStart(target)
                }
                return this.onAutoFillCancel(target)
            },
            onFocus(event) {
                if (!this.$refs.field) {
                    return
                }

                if (!this.readonly) {
                    event.target.select()
                } else {
                    this.$emit("click", event);
                }

                this.$refs.field.classList.add('focused');
            },
            onBlur(event) {
                if (!this.$refs.field) { 
                    return
                }

                this.$refs.field.classList.remove('focused');

                if (this.$refs.input.value === this.originalValue) {
                    console.log("Values not changed : ", this.originalValue, this.value);
                    return;
                }

                this.$emit("onValueChanged", this.$refs.input.value);

            },
            onChange: function () {
            },
            onArrowRight: function (e) {
                if (e.target.value.length === e.target.selectionStart) {
                    this.$emit('focusleave', {
                        dir: 'right',
                        target: e.target
                    })
                }
            },
            onArrowDown: function (e) {
                this.$emit('focusleave', {
                    dir: 'down',
                    target: e.target
                })
            },
            onArrowUp: function (e) {
                this.$emit('focusleave', {
                    dir: 'up',
                    target: e.target
                })
            },
            onArrowLeft: function (e) {
                if (e.target.selectionStart === 0) {
                    this.$emit('focusleave', {
                        dir: 'left',
                        target: e.target
                    })
                }
            },
            onKeyDown(e) {
                // console.log('emit keydown')
                this.$emit('keydown', e)
            },
            onKeyPress(e) {
                this.$emit('keypress', e)
            },
            handleInput(e) {
                this.$emit('input', e.target.value)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @keyframes onAutoFillStart {
        from { /**/
        }

        to { /**/
        }
    }

    @keyframes onAutoFillCancel {
        from { /**/
        }

        to { /**/
        }
    }

    input:-webkit-autofill {
        animation-name: onAutoFillStart;
        transition: background-color 50000s ease-in-out 0s;
    }

    input:not(:-webkit-autofill) {
        animation-name: onAutoFillCancel;
    }

    .field {
        color: #696B70;
        display: flex;
        flex-direction: column;
        // padding-top: 3px;
        position: relative;
        width: 100%;

        &:not(.readonly) {
            // &:hover .input {
            //     border-bottom-color: var(--color-brand);
            // }

            // .input {
            //     border-bottom: 1px solid #d2d2d2;
            // }
        }

        &.inline {
            height: 24px;
            padding-top: 0;
            line-height: 16px;

            .input {
                height: 24px;
            }

            input {
                font-size: 13px;
            }

        }
    }

    .append, .prepend {
        font-size: 13px;
    }

    label {
        display: block;
        font-weight: 300;
        font-size: 11px;
        transition: all .15s ease-out;
        margin-bottom: 0;

        span {
            color: #ABACAF;
            font-style: italic;
        }
    }

    .field.error {
        label {
            color: #FE6B5B;
        }

        .message {
            color: #FE6B5B;
        }
    }

    .message {
        text-align: right;
        font-size: 13px;
        line-height: 20px;
    }

    .input {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        // height: 24px;
        line-height: 24px;
        // padding: 0 0 4px 0;
    }

    input {
        background: transparent !important;
        width: 100%;
        outline: 0;
        font-size: 13px;
        // height: 24px;
        line-height: 24px;
        color: #292C33;
        font-weight: 400;
        // border-bottom: 1px solid #d2d2d2;

        &::placeholder {
            color: #ccc;
        }
    }

    .focused:not(.readonly) {
        &:not(.empty) {
            label {
                color: var(--color-brand);
            }
        }
    }

    // .empty {
    //     label {
    //         top: 3px;
    //         font-size: 14px;
    //     }
    // }

    .inline {
        input {
            font-size: 13px;
        }

        label {
            top: -10px;
        }

        // &.empty {
        //     label {
        //         top: 4px;
        //     }
        // }
    }

    .field.inverted {
        &:hover {
            .input {
                border-bottom-color: #fff;
            }

            label {
                color: #fff;
            }
        }

        &.focused {
            &:not(.empty) {
                label {
                    color: #fff;
                }
            }

            input {
                color: #fff !important;
            }

            .input {
                color: #eee;
                border-bottom: 1px solid #fff;
            }
        }

        .input {
            color: #eee;
            border-bottom: 1px solid #eee;
        }

        input {
            color: #eee;
        }

        label {
            color: #eee;
        }
    }

    input[type=number] {
        // text-align: right;
    }

        input[type=number]::-webkit-inner-spin-button,
        input[type=number]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
</style>
